import { asyncFlow } from '@helo/utils'
import { tap } from '@helo/utils'
import { flow } from '@helo/utils'

import { CookieCategory, UserSettingsQuery } from '../../../gql/graphql'
import { userSettingsQuery } from '../../../queries/graphql/graphqlQueries'
import { apolloClient } from '../../../services/apolloClient'
import { UserSettingsSlice } from './userSettingsSlice'

type RetrievedUserSettings<T extends UserSettingsSlice> = {
  data: UserSettingsQuery | undefined
  store: T
}

const setClarityCookieConsent = () =>
  flow(
    flow.inputExtends<UserSettingsSlice>(),
    tap(<T extends UserSettingsSlice>(store: T) => {
      if (
        store.userSettings.settings?.cookieCategories?.includes(
          CookieCategory.Analytics,
        )
      ) {
        window.clarity?.('consent')
      } else {
        window.clarity?.('consent', false)
      }
    }),
  )

const retrieveUserSettings = () =>
  asyncFlow(
    asyncFlow.inputExtends<UserSettingsSlice>(),
    async <T extends UserSettingsSlice>(
      store: T,
    ): Promise<RetrievedUserSettings<T>> => {
      const { data } = await apolloClient.query({
        query: userSettingsQuery,
      })
      return { data, store }
    },
    <T extends UserSettingsSlice>({
      data,
      store,
    }: RetrievedUserSettings<T>): RetrievedUserSettings<T> => ({
      data,
      store: {
        ...store,
        userSettings: {
          ...store.userSettings,
          settings: data?.userSettings,
        },
      },
    }),
    <T extends UserSettingsSlice>({ store }: RetrievedUserSettings<T>): T =>
      store,
  )

export const UserSettingsSliceParts = {
  setClarityCookieConsent,
  retrieveUserSettings,
}
